import { useEffect } from 'react'

// useClick :: Function -> _
const useClick = callback => {
  useEffect(() => {
    const handleClick = event => {
      callback(event)
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [callback])
}

export default useClick
